// #region Global Imports
import * as React from "react";
// #endregion Global Imports

// #region Local Imports
import { Button, Card, Text, Title } from "@Components/Basic";
import { Photo } from "@Icons";
import { theme } from "@Definitions"; 
import { Container } from "./styled";
// #endregion Local Imports

// #region Local Interface
import { IAddPhoto } from "./AddPhoto";
import { Col, Row } from "@Styled";
// #endregion Local Interface

const AddPhoto: React.FunctionComponent<IAddPhoto.IProps> = ({
    t,
    onClickAddPhotoButton,
}): JSX.Element => {
    return (
        <Card overflowHidden>
            <Container className="py-5 px-5 px-xl-9 text-center text-md-left align-items-lg-center text-lg-center">
                <Row className="no-gutters">
                    <Col className="col-3 col-lg-12 d-none d-md-flex justify-content-center align-items-center d-lg-none">
                        <Photo width="90px" height="90px" color={theme.colors.gray} />
                    </Col>
                    <Col className="col-12 col-md-9 col-lg-12">
                        <Title
                            className="mb-lg-4"
                            color="red"
                            size="large"
                            fontWeight="bold"
                            dangerouslySetInnerHTML={{
                                __html: t("dashboard:Widgets.AddPhoto.title"),
                            }}
                        />
                        <Photo width="268px" height="90px" color={theme.colors.gray} className="mb-6 d-none d-lg-block"/>
                        <Text
                            className="mb-3"
                            color="black"
                            size="large"
                            dangerouslySetInnerHTML={{
                                __html: t("dashboard:Widgets.AddPhoto.description"),
                            }}
                        />
                        <Button
                            styleType="gradient"
                            onClick={onClickAddPhotoButton}
                            className="text-uppercase"
                        >
                            {t("dashboard:Widgets.AddPhoto.addPhoto")}
                        </Button>
                    </Col>
                </Row>
            </Container>
        </Card>
    );
};

export { AddPhoto };
